import { ENVIRONMENTS, getEnvFromHostname } from 'pages/utils/getEnvFromHostname';

const envToCreditAccountScriptUrl: Record<ENVIRONMENTS, string> = {
  [ENVIRONMENTS.LOCALHOST]: 'http://localhost:4174/invoicing-customer-credit-account.es.js',
  [ENVIRONMENTS.DEVELOPMENT]: 'http://localhost:4174/invoicing-customer-credit-account.es.js',
  [ENVIRONMENTS.STAGING]:
    'https://ls-mfe-assets-cdn.lightspeedstg.app/invoicing/customer-credit-account/latest.js',
  [ENVIRONMENTS.PRODUCTION]:
    'https://ls-mfe-assets-cdn.lightspeed.app/invoicing/customer-credit-account/latest.js',
};

const envToInvoicesListScriptUrl: Record<ENVIRONMENTS, string> = {
  [ENVIRONMENTS.LOCALHOST]: 'http://localhost:4174/invoicing-customer-invoices-list.es.js',
  [ENVIRONMENTS.DEVELOPMENT]: 'http://localhost:4174/invoicing-customer-invoices-list.es.js',
  [ENVIRONMENTS.STAGING]:
    'https://ls-mfe-assets-cdn.lightspeedstg.app/invoicing/customer-invoices-list/latest.js',
  [ENVIRONMENTS.PRODUCTION]:
    'https://ls-mfe-assets-cdn.lightspeed.app/invoicing/customer-invoices-list/latest.js',
};

export const getCustomerCreditAccountScriptUrl = (): string =>
  envToCreditAccountScriptUrl[getEnvFromHostname()];

export const getCustomerInvoicesListScriptUrl = (): string =>
  envToInvoicesListScriptUrl[getEnvFromHostname()];

export const CUSTOMER_CREDIT_ACCOUNT_ELEMENT = 'invoicing-customer-credit-account';
export const CUSTOMER_INVOICES_LIST_ELEMENT = 'invoicing-customer-invoices-list';
